(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  const overlayIsOpen = (element) => {
    if (!element?.isConnected) return false;
    if (element.matches('cart-drawer')) return element.classList.contains('active');
    if (element.matches('details-modal')) return Boolean(element.querySelector(':scope > details[open]'));
    if (element.matches('header-drawer, menu-drawer')) {
      return Boolean(element.querySelector(':scope > details[open]'));
    }
    if (element.matches('modal-dialog, quick-add-modal')) return element.hasAttribute('open');
    return false;
  };

  const findOpenOverlay = () =>
    document.querySelector('quick-add-modal[open], modal-dialog[open]') ||
    (document.querySelector('details-modal > details[open]')?.closest('details-modal') ?? null) ||
    document.querySelector('cart-drawer.active') ||
    (document.querySelector('header-drawer > details[open]')?.closest('header-drawer') ?? null) ||
    (document.querySelector('menu-drawer > details[open]')?.closest('menu-drawer') ?? null);

  const closeOverlay = (overlay) => {
    if (!overlay) return;
    if (typeof overlay.hide === 'function') {
      overlay.hide();
      return;
    }
    if (typeof overlay.close === 'function') {
      overlay.close();
      return;
    }
    if (overlay.matches('details-modal') && typeof overlay.close === 'function') {
      overlay.close();
      return;
    }
    if (overlay.matches('header-drawer, menu-drawer')) {
      const details = overlay.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (typeof overlay.closeMenuDrawer === 'function' && summary) {
        overlay.closeMenuDrawer(new KeyboardEvent('keyup', { key: 'Escape', code: 'Escape' }), summary);
      } else {
        details?.removeAttribute('open');
      }

      // Dawn removes `open` after its closing animation. When the close comes
      // from browser history, remove it immediately so the overlay cannot
      // remain visible after the drawer has already left the screen.
      details?.removeAttribute('open');
      details?.classList.remove('menu-opening');
      details?.querySelectorAll('details[open]').forEach((nestedDetails) => {
        nestedDetails.removeAttribute('open');
        nestedDetails.classList.remove('menu-opening');
      });
      details?.querySelectorAll('.submenu-open').forEach((submenu) => submenu.classList.remove('submenu-open'));
      summary?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
      overlay.closest('.section-header')?.classList.remove('menu-open');
    }
  };

  let activeOverlay = null;
  let activeToken = null;
  let scheduled = false;
  let consumingHistory = false;

  const synchronizeOverlayHistory = () => {
    scheduled = false;
    if (!mobile.matches) return;
    const openOverlay = findOpenOverlay();

    if (openOverlay && openOverlay !== activeOverlay) {
      activeOverlay = openOverlay;
      activeToken = `velora-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      history.pushState({ ...(history.state || {}), veloraOverlay: activeToken }, '', window.location.href);
      return;
    }

    if (!openOverlay && activeOverlay) {
      activeOverlay = null;
      if (history.state?.veloraOverlay === activeToken && !consumingHistory) {
        consumingHistory = true;
        history.back();
      }
      activeToken = null;
    }
  };

  const scheduleOverlaySynchronization = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(synchronizeOverlayHistory);
  };

  window.addEventListener('popstate', () => {
    if (!mobile.matches) return;
    if (consumingHistory) {
      consumingHistory = false;
      return;
    }
    const overlay = activeOverlay && overlayIsOpen(activeOverlay) ? activeOverlay : findOpenOverlay();
    activeOverlay = null;
    activeToken = null;
    if (overlay) closeOverlay(overlay);
  });

  let observer = null;

  const startMobileExperience = () => {
    if (!mobile.matches || observer) return;
    observer = new MutationObserver(() => {
      scheduleOverlaySynchronization();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'open']
    });
    scheduleOverlaySynchronization();
  };

  const stopMobileExperience = () => {
    observer?.disconnect();
    observer = null;
  };

  const start = () => {
    startMobileExperience();
    mobile.addEventListener?.('change', (event) => {
      if (event.matches) {
        startMobileExperience();
      } else {
        stopMobileExperience();
      }
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
